(function() {
  if (window.__xtxReviewVideoCaptureBound) return;
  window.__xtxReviewVideoCaptureBound = true;

  var activeMedia = null;
  var downX = 0;
  var downY = 0;

  function xtxVideoPoint(event) {
    var touch = event.changedTouches && event.changedTouches[0] || event.touches && event.touches[0];
    return touch || event;
  }

  function xtxReviewYoutubeId(url) {
    var match = (url || '').match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    return match ? match[1] : '';
  }

  function xtxReviewMediaFromEvent(event) {
    if (!event.target || !event.target.closest) return null;
    return event.target.closest('.xtx-reviews .xtx-review__media');
  }

  function xtxReviewCanPlay(media) {
    if (!media || media.classList.contains('is-playing') || media.dataset.xtxLoading === '1') return false;
    var platform = (media.getAttribute('data-platform') || '').toLowerCase();
    var url = media.getAttribute('data-video-url') || '';
    return platform === 'youtube' && !!xtxReviewYoutubeId(url);
  }

  function xtxReviewStopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function xtxReviewLoadYoutube(media) {
    if (!xtxReviewCanPlay(media)) return false;
    var url = media.getAttribute('data-video-url') || '';
    var id = xtxReviewYoutubeId(url);
    if (!id) return false;
    media.dataset.xtxLoading = '1';

    var player = document.createElement('div');
    player.className = 'xtx-review__media is-playing';
    player.setAttribute('data-platform', 'youtube');
    player.setAttribute('data-video-url', url);
    player.innerHTML = '<iframe title="YouTube video player" loading="eager" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1"></iframe>';

    if (media.parentNode) {
      media.parentNode.replaceChild(player, media);
      return true;
    }
    return false;
  }

  function xtxReviewPressStart(event) {
    var media = xtxReviewMediaFromEvent(event);
    if (!xtxReviewCanPlay(media)) return;
    var p = xtxVideoPoint(event);
    activeMedia = media;
    downX = p.clientX || 0;
    downY = p.clientY || 0;
  }

  function xtxReviewPressEnd(event) {
    var media = xtxReviewMediaFromEvent(event) || activeMedia;
    if (!xtxReviewCanPlay(media)) return;

    if (event.type !== 'click') {
      var p = xtxVideoPoint(event);
      var dx = Math.abs((p.clientX || 0) - downX);
      var dy = Math.abs((p.clientY || 0) - downY);
      if (dx > 14 || dy > 14) return;
    }

    xtxReviewStopEvent(event);
    xtxReviewLoadYoutube(media);
    activeMedia = null;
  }

  document.addEventListener('pointerdown', xtxReviewPressStart, true);
  document.addEventListener('touchstart', xtxReviewPressStart, true);
  document.addEventListener('pointerup', xtxReviewPressEnd, true);
  document.addEventListener('touchend', xtxReviewPressEnd, true);
  document.addEventListener('click', xtxReviewPressEnd, true);
})();

(function() {
  if (window.__xtxPremiumBound) return;
  window.__xtxPremiumBound = true;

  function xtxYoutubeId(url) {
    var match = (url || '').match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    return match ? match[1] : '';
  }

  function xtxLoadYoutubePlayer(media, url) {
    var youtubeId = xtxYoutubeId(url);
    if (!media || !youtubeId) return;

    var player = document.createElement('div');
    player.className = 'xtx-review__media is-playing';
    player.setAttribute('data-platform', 'youtube');
    player.setAttribute('data-video-url', url || '');
    player.innerHTML = '<iframe title="YouTube video player" loading="eager" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen src="https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0&playsinline=1"></iframe>';

    if (media.parentNode) {
      media.parentNode.replaceChild(player, media);
    }
  }

  function xtxPrepareMedia(root) {
    (root || document).querySelectorAll('.xtx-review__media').forEach(function(media) {
      if (media.classList.contains('is-playing')) return;
      var platform = media.getAttribute('data-platform');
      var url = media.getAttribute('data-video-url');
      var hasMerchantImage = media.querySelector('img:not(.xtx-placeholder):not(.xtx-auto-cover)');
      if (hasMerchantImage) {
        media.classList.add('has-cover-image');
        return;
      }
      if (platform === 'youtube') {
        var id = xtxYoutubeId(url);
        if (id) {
          media.querySelectorAll('svg').forEach(function(svg) { svg.remove(); });
          if (!media.querySelector('.xtx-auto-cover')) {
            var img = document.createElement('img');
            img.className = 'xtx-auto-cover';
            img.alt = 'YouTube video cover';
            img.loading = 'lazy';
            img.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
            img.onerror = function() {
              if (img.dataset.fallbackReady) return;
              img.dataset.fallbackReady = 'true';
              img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
            };
            media.insertBefore(img, media.firstChild);
          }
          media.classList.add('has-auto-cover');
        }
      }
    });
  }

  function xtxEnableDrag(track) {
    if (!track || track.dataset.xtxDragReady) return;
    track.dataset.xtxDragReady = 'true';
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;
    var threshold = track.hasAttribute('data-xtx-social-tabs') ? 14 : 6;

    track.addEventListener('pointerdown', function(e) {
      if (e.button !== undefined && e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture && track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function(e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > threshold) moved = true;
      track.scrollLeft = scrollLeft - delta;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      track.releasePointerCapture && track.releasePointerCapture(e.pointerId);
      setTimeout(function() { moved = false; }, 120);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function(e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function xtxCenterElementInTrack(track, item, behavior) {
    if (!track || !item) return;
    var left = item.offsetLeft - ((track.clientWidth - item.offsetWidth) / 2);
    track.scrollTo({ left: Math.max(0, left), behavior: behavior || 'smooth' });
  }

  function xtxStartElementInTrack(track, item, behavior) {
    if (!track || !item) return;
    var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    track.scrollTo({ left: Math.max(0, item.offsetLeft - pad), behavior: behavior || 'smooth' });
  }

  function xtxCenterSocialTab(reviews, tab, behavior) {
    if (!reviews || !tab) return;
    var row = tab.closest('.xtx-socials');
    var filter = tab.getAttribute('data-xtx-filter');
    reviews.dataset.currentFilter = filter || reviews.dataset.currentFilter || 'youtube';
    if (filter === 'youtube') {
      row && row.scrollTo({ left: 0, behavior: behavior || 'smooth' });
      return;
    }
    xtxCenterElementInTrack(row, tab, behavior || 'smooth');
  }

  function xtxCenterActiveSocial(root, behavior) {
    (root || document).querySelectorAll('.xtx-reviews').forEach(function(reviews) {
      var tab = reviews.querySelector('[data-xtx-filter].is-active') || reviews.querySelector('[data-xtx-filter="youtube"]') || reviews.querySelector('[data-xtx-filter]');
      if (!tab) return;
      reviews.dataset.currentFilter = tab.getAttribute('data-xtx-filter') || 'youtube';
      window.setTimeout(function() { xtxCenterSocialTab(reviews, tab, behavior || 'auto'); }, 80);
    });
  }

  function xtxCenterFirstVisibleReview(reviews, behavior) {
    var track = reviews && reviews.querySelector('[data-xtx-carousel]');
    if (!track) return;
    var firstVisible = Array.prototype.find.call(track.querySelectorAll('[data-xtx-platform-card]'), function(card) {
      return !card.hidden;
    });
    if (!firstVisible) return;
    window.setTimeout(function() {
      if (reviews.dataset.currentFilter === 'youtube') {
        track.scrollTo({ left: 0, behavior: behavior || 'smooth' });
      } else {
        xtxStartElementInTrack(track, firstVisible, behavior || 'smooth');
      }
    }, 40);
  }

  function xtxInit(root) {
    xtxPrepareMedia(root);
    (root || document).querySelectorAll('[data-xtx-carousel]').forEach(xtxEnableDrag);
    (root || document).querySelectorAll('[data-xtx-social-tabs]').forEach(xtxEnableDrag);
    xtxCenterActiveSocial(root, 'auto');
    (root || document).querySelectorAll('.xtx-reviews').forEach(function(reviews) {
      xtxCenterFirstVisibleReview(reviews, 'auto');
    });
  }

  document.addEventListener('DOMContentLoaded', function() { xtxInit(document); });
  document.addEventListener('shopify:section:load', function(e) { xtxInit(e.target); });
  document.addEventListener('shopify:section:select', function(e) { xtxCenterActiveSocial(e.target, 'smooth'); });
  window.addEventListener('resize', function() {
    xtxCenterActiveSocial(document, 'auto');
    document.querySelectorAll('.xtx-reviews').forEach(function(reviews) { xtxCenterFirstVisibleReview(reviews, 'auto'); });
  });

  document.addEventListener('click', function(e) {
    var originTab = e.target.closest('[data-xtx-origin-tab]');
    if (originTab) {
      var origin = originTab.closest('.xtx-origin');
      var target = originTab.getAttribute('data-xtx-origin-tab');
      origin.querySelectorAll('[data-xtx-origin-tab]').forEach(function(tab) {
        tab.classList.toggle('is-active', tab === originTab);
      });
      origin.querySelectorAll('[data-xtx-origin-panel]').forEach(function(panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-xtx-origin-panel') === target);
      });
    }

    var socialTab = e.target.closest('[data-xtx-filter]');
    if (socialTab) {
      var reviews = socialTab.closest('.xtx-reviews');
      if (reviews) {
        var filter = socialTab.getAttribute('data-xtx-filter');
        e.preventDefault();
        reviews.dataset.currentFilter = filter;
        reviews.dataset.xtxTouched = '1';
        reviews.querySelectorAll('[data-xtx-filter]').forEach(function(tab) {
          var active = tab === socialTab;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        reviews.querySelectorAll('[data-xtx-platform-card]').forEach(function(card) {
          card.hidden = filter !== 'all' && card.getAttribute('data-xtx-platform-card') !== filter;
        });
        xtxCenterSocialTab(reviews, socialTab, 'smooth');
        xtxCenterFirstVisibleReview(reviews, 'smooth');
      }
    }

    var arrow = e.target.closest('[data-xtx-scroll]');
    if (arrow) {
      var carousel = arrow.closest('.xtx-carousel');
      var track = carousel && carousel.querySelector('[data-xtx-carousel]');
      if (!track) return;
      var action = arrow.getAttribute('data-xtx-scroll');
      var dir = action === 'right' || action === 'next' ? 1 : -1;
      track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.82), behavior: 'smooth' });
    }

    var specTab = e.target.closest('[data-xtx-tab]');
    if (specTab) {
      var spec = specTab.closest('.xtx-spec');
      var id = specTab.getAttribute('data-xtx-tab');
      spec.querySelectorAll('[data-xtx-tab]').forEach(function(tab) {
        tab.classList.toggle('is-active', tab === specTab);
      });
      spec.querySelectorAll('[data-xtx-panel]').forEach(function(panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-xtx-panel') === id);
      });
    }

    var media = e.target.closest('.xtx-review__media');
    if (!media || media.classList.contains('is-playing')) return;
    var platform = media.getAttribute('data-platform');
    var url = media.getAttribute('data-video-url');
    if (!url) return;
    if (platform === 'youtube') {
      e.preventDefault();
      xtxLoadYoutubePlayer(media, url);
    } else {
      window.open(url, '_blank', 'noopener');
    }
  });
})();
